<template>
  <div
    class="has-margin-left-100-desktop has-margin-right-100-desktop has-margin-top-25-desktop has-margin-bottom-15-desktop"
    style-prop="width:100%;height:82vh"
    :class="screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'"
  >
    <account-base
      v-if="accountsDialog.display"
      style-prop="width:100%;height:82vh"
      :type="accountsDialog.type"
      @change="accountsDialog.type = $event"
      @close=";(accountsDialog.display = false), (accountsDialog.type = '')"
    ></account-base>
  </div>
</template>
<script>
import AccountBase from '@/components/Accounts/AccountBase'
import { mapGetters } from 'vuex'
export default {
  components: {
    AccountBase
  },
  data() {
    return {
      accountsDialog: {
        display: true,
        type: 'sign-in'
      }
    }
  },
  computed: {
    ...mapGetters({ screen: 'getScreen' })
  },
  mounted() {
    window.history.pushState('page2', 'Title', `/sign-in`)
    if (this.$route.query.errorMessage) {
      this.notifyError(this.$route.query.errorMessage)
    }
  }
}
</script>
